/**
 * lxb-hover-loader.js
 * Loads product hover images on-demand (mouseenter / touchstart only).
 * The placeholder <img> carries data-hover-src and data-hover-srcset;
 * this script swaps in the real src/srcset on first interaction.
 */
(function () {
  'use strict';

  function upgradeHoverImg(card) {
    var img = card.querySelector('.lxb-hover-placeholder');
    if (!img || img.dataset.upgraded) return;
    img.dataset.upgraded = '1';

    var realSrc    = img.dataset.hoverSrc;
    var realSrcset = img.dataset.hoverSrcset;

    if (!realSrc) return;

    // Pre-fetch via Image() so the browser caches it before we swap
    var preload = new window.Image();
    preload.onload = function () {
      img.srcset = realSrcset || '';
      img.src    = realSrc;
    };
    preload.src = realSrc;
  }

  function attachListeners() {
    var cards = document.querySelectorAll('.grid-product');
    cards.forEach(function (card) {
      card.addEventListener('mouseenter',  function () { upgradeHoverImg(this); }, { once: true });
      card.addEventListener('touchstart',  function () { upgradeHoverImg(this); }, { once: true, passive: true });
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

  // Re-attach after AJAX collection filtering / pagination (theme fires this event)
  document.addEventListener('collection:reloaded', attachListeners);
  document.addEventListener('ajaxCart:added',      attachListeners);
})();
